import React, { FC, useState } from "react";
import {
  InputNumber,
  InputText,
} from "../../../../components/input";

import {
  IInputArrayFormProps,
  IInputArrayDataStructureItem,
} from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import {
  getDDMMYYYFormat,
} from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { UploadFile } from "../../uploadFile";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import { InputSelectTag } from "../../../../components/input/select-tag";
import { Upload } from "../../upload";
import { InputGroupSelect } from "../../../../components/input/select/select-group";
import { getDefaultEstimatedTimeOfUse, getDefaultGender } from "../../util";

export const ShortTermSercurityCardUnitsFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfIDCard",
    label: "Bản CMND photo công chứng trong thời hạn 6 tháng (Mặt trước)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfIDCardOpSide",
    label: "Bản CMND photo công chứng trong thời hạn 6 tháng (Mặt sau nếu có)",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];

export const ShortTermSercurityCardUnitsControlForm: FC<IInputArrayFormProps> = (
  props: any
) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => { 
      values.grantTerm = estimatedTimeOfUse ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1]) : values.grantTerm;
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === 'male' ? 'Nam' : "Nữ"
      // values.grantedArea = values.grantedArea.length > 0 ? JSON.stringify(values.grantedArea) : [];
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        // !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea 
        // !values.photocopyOfIDCard 
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      else
      props.onSubmit(values);
    },
  });

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  }

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => 
          <InputText {...s}/>}
          // <InputSelect {...s} 
          //     options={props.teamList.map((o: any) => ({
          //       id: o.id,
          //       label: o.value,
          //       value: o.value,
          //     }))}
          //     value={selectedTeam?.value}
          //     onChange={onTeamChange}
          //     placeholder="* Chọn Đơn vị"
          // />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("name")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => 
          <InputSelectTag 
            {...s}
            options={genderSelect} 
            value={gender}
            onChange={onGenderChange}
            gender={gender}
          />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("personalId")}
        renderInput={(s) => <InputNumber {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("regency")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
      /> */}

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => 
        <InputDateRangePicker {...s} 
          value={estimatedTimeOfUse}
          onChange={setEstimatedTimeOfUse}
          minDate={today}
        />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("photocopyOfIDCardOpSide")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      {/* <InputWraper
        inputProps={getInputProps("excuse")}
        renderInput={(s) => <Upload {...s} />}
      /> */}
    
      <InputWraper
        inputProps={getInputProps("note")}
        renderInput={(s) => <InputText {...s} />}
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};

export const ShortTermRenewSercurityCardUnitsFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "KSANCardNumberIssued",
    label: "Số thẻ KSAN đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfIDCard",
    label: "Bản CMND photo công chứng trong thời hạn 6 tháng (Mặt trước)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfIDCardOpSide",
    label: "Bản CMND photo công chứng trong thời hạn 6 tháng (Mặt sau nếu có)",
    isVisibleOnList: true,
  },
  {
    name: "excuse",
    label: "Đơn cớ mất (TH cấp lại thẻ vui lòng cung cấp)",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];

export const ShortTermRenewSercurityCardUnitsControlForm: FC<IInputArrayFormProps> = (
  props: any
) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue:
          ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => { 
      values.grantTerm = estimatedTimeOfUse ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1]) : values.grantTerm;
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === 'male' ? 'Nam' : "Nữ"
      values.excuse = values.excuse.length > 0 && JSON.stringify(values.excuse);
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        // !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea ||
        // !values.photocopyOfIDCard  || 
        !values.excuse 
        // !values.KSANCardNumberIssued
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      else
      props.onSubmit(values);
    },
  });

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  }

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc
        phải nhập{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => 
          <InputText {...s}/> }
          // <InputSelect {...s} 
          //     options={props.teamList.map((o: any) => ({
          //       id: o.id,
          //       label: o.value,
          //       value: o.value,
          //     }))}
          //     value={selectedTeam?.value}
          //     onChange={onTeamChange}
          //     placeholder="* Chọn Đơn vị"
          // />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("name")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => 
          <InputSelectTag 
            {...s}
            options={genderSelect} 
            value={gender}
            onChange={onGenderChange}
            gender={gender}
          />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("personalId")}
        renderInput={(s) => <InputNumber {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("regency")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => 
        <InputDateRangePicker {...s} 
          value={estimatedTimeOfUse}
          onChange={setEstimatedTimeOfUse}
          minDate={today}
        />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("photocopyOfIDCardOpSide")}
        renderInput={(s) => <UploadFile {...s} />}
      />

      <InputWraper
        inputProps={getInputProps("excuse")}
        renderInput={(s) => <Upload {...s} />}
        isRequired
      />
    
      <InputWraper
        inputProps={getInputProps("note")}
        renderInput={(s) => <InputText {...s} />}
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};

